<template></template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { RegistrationApiResponse } from '@/src/components/addons/registration/types';
import { Cache } from '@/src/services/cache';
import { events } from '@/src/services/events';
import { registerRepeatable, updateRepeatable } from '@/src/services/repeatable';
import type { AddonGameplayModel } from '@/src/components/addons/gameplay/Model';
import type { GameDropGameState } from '@/src/components/games/dropgame/Model';
import { useCampaignStore } from '@/src/store/campaign';

interface ScoreState {
  [key: string]: string | number;
}

export interface DropgameRegistrationResponse extends RegistrationApiResponse {
  score_top_10?: ScoreState;
}

interface DropGameRepeatableData {
  rank: number;
  id: number;
  score: number;
  [key: string]: string | number;
}

export default defineComponent({
  name: 'DropGameInitializer',
  setup() {
    const campaignStore = useCampaignStore();
    const campaignModel = campaignStore.model;

    registerRepeatable('score_top10', async () => {
      const dropgameData: DropGameRepeatableData[] = [];

      campaignModel?.state.flowPages.forEach((pageModel) => {
        pageModel.getAddons<AddonGameplayModel>('gameplay').forEach((gameplayModel) => {
          const dropgameGameModel = gameplayModel.state.settings?.game;
          const dropgameGameState = dropgameGameModel?.state as GameDropGameState;

          if (dropgameGameState.repeatable?.scoreTop10) {
            dropgameGameState.repeatable.scoreTop10.forEach((item) => {
              dropgameData.push({
                rank: item.id + 1, // Or else it would be 0
                id: item.id + 1, // Or else it would be 0
                score: item.score
              });
            });
          }
        });
      });

      return dropgameData;
    });

    events.on('formSubmitResponse', (event) => {
      const response: DropgameRegistrationResponse = event.detail.response;

      if (response.score_top_10) {
        Cache.set<ScoreState>('top_10_score', response.score_top_10);
        updateRepeatable('score_top10');
      }
    });

    return {};
  }
});
</script>
